<template>
  <div
    class="audio-box"
    :class="{
      show: isShowTab,
      hide: !isShowTab,
      'sort-width': isSortWidth,
      'long-width': !isSortWidth,
      tourGLaudio:className,
      
      
    }"
    :style="className=='higher'? 'bottom:270px !important;top:52%;':''"
    
    :id="audioInfo.direction==2 ?'bottom-box':'audio-box'"
    
    ref="audiobox"
    @click="setWidth('open')"
  >
    <div>
      <div class="check-audio">
        <img
          src="@/static/imgs/close.png"
          alt
          v-show="!isPlay"
          @click.stop="changePlay"
          class="play-img"
        />
        <img
          src="@/static/imgs/play.png"
          alt
          v-show="isPlay"
          @click.stop="changePlay"
          class="play-img"
        />
        <img
          :src="imgHost + playIngData.img"
          alt=""
          v-show="isSortWidth"
          class="corver-img"
          :class="{ 'rotate-box': isPlay }"
        />
      </div>
      <div class="progress-list" v-show="!isSortWidth">
        <p class="title">
          <span class="scence-name">{{
            isEnglish ? playIngData.name_eng : playIngData.name
          }}</span>
          <span class="distance">{{ distance }}</span>
        </p>
        <p class="content">
          <img
            src="@/static/imgs/fastsecond.png"
            alt
            class="fastsecond"
            @click="goTime(-15)"
          />
          <span class="time" style="margin-left: 0.08rem">{{
            currentTime
          }}</span>
          <span class="progress" @click="changeProgress" ref="progress">
            <span
              class="progress-total"
              :style="{ width: total + 'rem' }"
            ></span>
            <span
              :style="{ left: total + 'rem' }"
              class="progress-item"
              @touchmove="moveProgress"
              ref="progressitem"
            ></span>
          </span>
          <span class="time" style="margin-right: 0.08rem">{{
            durationTime
          }}</span>
          <img
            src="@/static/imgs/fastsecond.png"
            alt
            class="fastsecond"
            @click="goTime(15)"
          />
        </p>
      </div>
      <i
        class="wack wack-guanbi1"
        @click.stop="setWidth('close')"
        
      ></i>
      <audio id="audio" ref="shakeAudio" :src="nowAudio"></audio>
    </div>
  </div>
</template>
<script>
import eventBus from "@/utils/eventBus";
import iconx from "./iconx";
import { setOffset } from "@/api/util.js";

import { imgHost,playNum } from "@/api/api";
import { distanceEnglishMap } from "@/static/const.js";
export default {
  props: {
    spointx: {
      type: Number,
      default: null,
    },
    spointy: {
      type: Number,
      default: null,
    },
    isEnglish: {
      type: Boolean,
      default: false,
    },
    weatherData: {
      type: Object,
      default: () => {},
    },
    audioInfo:{
      type: Object,
      default: () => {},
    },
    className:{
      type:String,
      default:""
    },
    isOpenAudio:false

  },
  components: {
    iconx,
  },
  watch: {
    isOpenAudio(val){
      console.log(val)
    },
    isPlay(val){
      console.log(val)
      if(val){
        this.computedPlayNum()
      }
    },
    audioInfo(val){
      console.log(val)
      
    },
    isEnglish: {
      handler(val) {
        console.log(val)
        if (JSON.stringify(this.playIngData) !== "{}") {
          let shakeAudio = document.getElementById("audio");
          this.nowAudio = val
            ? imgHost + this.playIngData.sound_eng
            : imgHost + this.playIngData.sound;
          shakeAudio.pause();
          shakeAudio.currentTime = 0;
          this.isPlay = false;
          this.total = 0;
          eventBus.emit("changeMarker", "pause");
        }
      },
    },
  },
  computed: {
    distance() {
      let newLagLng = new TMap.LatLng(this.spointx, this.spointy);
      if (JSON.stringify(this.playIngData) !== "{}" && this.playIngData) {
        let arr = this.playIngData.coordinate.split(",");
        let path = [newLagLng, new TMap.LatLng(arr[1], arr[0])];
        let distance = Math.floor(TMap.geometry.computeDistance(path)) + "";
        if (distance.length >= 4) {
          return (
            (distance / 1000).toFixed(3) +
            (this.isEnglish ? distanceEnglishMap["千米"].english : "千米")
          );
        } else {
          return (
            distance +
            (this.isEnglish ? distanceEnglishMap["米"].english : "米")
          );
        }
      } else {
        return "0";
      }
    },
  },
  mounted() {
    this.initEventBus();
    this.initEvent();
    // console.log(this.audioInfo)
  },
  data() {
    return {
      nowAudio: "",
      isPlay: false,
      durationTime: "0:00",
      currentTime: "0:00",
      total: 0,
      soundName: "",
      playIngData: {},
      isShowTab: false,
      isSortWidth: false,
      coverImg: "",
      imgHost,
      playInfoId:"",
      num:0
    };
  },
  methods: {
    computedPlayNum(){
      playNum({id:this.playInfoId}).then(res=>{
          console.log(res)
        })
    },
    initEvent() {
      let shakeAudio = document.getElementById("audio");
      let that = this;
      shakeAudio.addEventListener("canplay", function () {
        //监听audio是否加载完毕，如果加载完毕，则读取audio播放时间
        that.computedTime();
      });
      shakeAudio.loop = false;
      shakeAudio.addEventListener("playing", function () {
        that.isPlay = true;
        eventBus.emit("repletePlay", that.playIngData);
      });
      shakeAudio.addEventListener("pause", function () {
        that.isPlay = false;
        eventBus.emit("closeIcon", "pause");
      });
      shakeAudio.addEventListener(
        "ended",
        function () {
          that.isPlay = false;
          that.$parent.changeAudioState();
        },
        false
      );
      // 监听播放进度
      shakeAudio.addEventListener("timeupdate", function () {
        let arr = shakeAudio.currentTime;
        that.currentTime =
          Math.floor(shakeAudio.currentTime / 60) +
          ":" +
          (
            ((shakeAudio.currentTime -
              Math.floor(shakeAudio.currentTime / 60) * 60) /
              100) *
            60
          ).toFixed(0);
        that.total = (shakeAudio.currentTime / shakeAudio.duration) * 2.9;
      });
    },
    initEventBus() {
      let shakeAudio = document.getElementById("audio");
      let that = this;
      eventBus.on("changeAudioSrc", (message) => {
        console.log(message)
        this.playInfoId=message.id
      
        this.playIngData = message;
        // 一些操作，message就是从top组件传过来的值
        this.nowAudio = this.isEnglish
          ? imgHost + message.sound_eng
          : imgHost + message.sound;
        this.coverImg = imgHost + message.img;
        setTimeout(() => {
          shakeAudio.play();
          that.isPlay = true;
        }, 0);
      });
      eventBus.on("showTab", (message) => {
        that.isShowTab = message;
      });
      eventBus.on("closeAudio", (message) => {
        if (message && typeof message === "boolean") {
          shakeAudio.currentTime = 0;
        }
        that.isPlay = false;
        shakeAudio.pause();
      });
    },
    goTime(time) {
      let mapAddress = this.$parent.$refs.mapAddress;
      if(mapAddress){
        
         if(!this.className){
         mapAddress.infoWindowMap.close();

        }
        // 未支付状态
      if (!mapAddress.isBuy && Number(this.playIngData.type) === 1) {
        mapAddress.showPrizeDialog();
        return;
      }
      let shakeAudio = document.getElementById("audio");
      // 到达播放时间不足15s
      if (shakeAudio.duration < shakeAudio.currentTime + time) {
        this.isPlay = false;
        shakeAudio.currentTime = shakeAudio.duration;
        return;
      }
      // 快退15s后达不到0s
      if (shakeAudio.currentTime + time < 0) {
        this.isPlay = false;
        shakeAudio.currentTime = 0;
        return;
      }
      }
      
      this.isPlay = true;
      shakeAudio.currentTime = shakeAudio.currentTime + time;
      shakeAudio.play();
    },
    setDefaultMusic(message) {
      // console.log(message)
      if (!this.nowAudio) {
        this.playIngData = message;

        // 一些操作，message就是从top组件传过来的值
        this.nowAudio = this.isEnglish
          ? imgHost + message.sound_eng
          : imgHost + message.sound;
        this.coverImg = imgHost + message.img;
        setTimeout(() => {
          this.computedTime();
        }, 300);
      }
    },
    setWidth(type) {
      this.$emit("audioOpen",false)
      // if (type === "open" && this.isSortWidth) {
      //   this.isSortWidth = false;
      // } else if (type === "close") {
      //   this.isSortWidth = true;
      // } else {
      //   return;
      // }
    },
    moveProgress(e) {
      if (e.target.className !== "progress-item") {
        return;
      }
      let mapAddress = this.$parent.$refs.mapAddress;
      // 计算总左偏移量

      let offsetX = setOffset(e.target) - this.$refs.audiobox.offsetWidth / 2 - this.$refs.progressitem.offsetLeft;
      // 计算手指距离屏幕左边的距离
      let touchesPagex = e.touches[0].pageX;
      // 计算手指在滚动条的位置
      let moveLeft = touchesPagex - offsetX;
      if (moveLeft >= this.$refs.progress.clientWidth) {
        moveLeft = this.$refs.progress.clientWidth;
      }

      // 如果开启自动播放,除当前正在播放的讲解, 禁止用户自己切换讲解
      if (
        this.$parent.isOpenAudio &&
        mapAddress.removeId !== this.playIngData.id
      ) {
        eventBus.emit(
          "showMessage",
          "如需播放该音频,请先关闭右上角自动播放按钮"
        );
        return;
      }
      // 未支付禁止用户拖动进度条
      if (!mapAddress.isBuy && Number(this.playIngData.type) === 1) {
        mapAddress.showPrizeDialog();
        return;
      }
      let pageX = e.touches[0].pageX;
      let preWidth = moveLeft;
      let allWidth = this.$refs.progress.clientWidth;
      this.total = (preWidth / allWidth) * 2.9;
      this.$refs.shakeAudio.play();
      this.$refs.shakeAudio.currentTime =
        (this.$refs.shakeAudio.duration * preWidth) / allWidth;
    },
    changePlay() {
      let mapAddress = this.$parent.$refs.mapAddress;
      if(mapAddress){
         if(!this.className){
         mapAddress.infoWindowMap.close();

        }
        // 未支付状态
        if (!mapAddress.isBuy && Number(this.playIngData.type) === 1) {
          mapAddress.showPrizeDialog();
          return;
        }
        if (this.isPlay) {
          this.$refs.shakeAudio.pause();
          eventBus.emit("changeMarker", "pause");
        } else {
          // 如果开启自动播放,除当前播放的这首讲解,禁止用户自己切换讲解
          if (
            this.$parent.isOpenAudio &&
            this.playIngData.id !== mapAddress.removeId
          ) {
            eventBus.emit(
              "showMessage",
              "如需播放该音频,请先关闭右上角自动播放按钮"
            );
            return;
          }
          this.$refs.shakeAudio.play();
          eventBus.emit("changeMarker", "play");
        }
      }
      
      this.isPlay = !this.isPlay;
    },
    computedTime() {
      if(this.$refs.shakeAudio.duration){
        this.durationTime =(Math.floor(this.$refs.shakeAudio.duration / 60) || 0) +
          ":" +
          (
            ((this.$refs.shakeAudio.duration -
              Math.floor(this.$refs.shakeAudio.duration / 60) * 60) /
              100) *
              60 || "00"
          ).toFixed(0);
      }
    },
    changeProgress(event) {
      let mapAddress = this.$parent.$refs.mapAddress;
      // 如果开启自动播放,除当前正在播放的讲解, 禁止用户自己切换讲解
      if (
        this.$parent.isOpenAudio &&
        mapAddress.removeId !== this.playIngData.id
      ) {
        eventBus.emit(
          "showMessage",
          "如需播放该音频,请先关闭右上角自动播放按钮"
        );
        return;
      }
      // 未支付禁止用户拖动进度条
      if (!mapAddress.isBuy && Number(this.playIngData.type) === 1) {
        mapAddress.showPrizeDialog();
        return;
      }
      let preWidth = event.offsetX || event.target.offsetLeft;
      let allWidth = this.$refs.progress.clientWidth;
      this.$refs.shakeAudio.currentTime =
        (this.$refs.shakeAudio.duration * preWidth) / allWidth;
    },
  },
};
</script>
<style lang="scss" scoped>
@font-face {
  font-family: "wack";
  src: url("//at.alicdn.com/t/font_992732_u4gt0pfn0k.ttf?t=1603462775159")
    format("truetype");
}
.wack-kaiqi3:before {
  content: "\e6a4";
}
i {
  font-size: 17px;
}
.wack {
  display: block;
  font-family: "wack" !important;
  font-size: 17px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.wack-guanbi1:before {
  content: "\e629";
}
.wack-guanbi1 {
  position: absolute;
  right: 0.16rem;
  top: 0.08rem;
  font-size: 22px ;
}

#bottom-box.hide {
  bottom: 100px ;
  
  transition: bottom 0.2s ease-in-out ;
}
.hide {
 
  bottom: 57px ;
  transition: bottom 0.2s ease-in-out ;
}
.tourGLaudio{
  position: absolute ;
  top: 0 ;
  bottom: 0 ;
  
}
#bottom-box.show {
  bottom: 100px ;
  transition: bottom 0.35s ease-in-out ;
}
.show {
  bottom: 250px ;
  transition: bottom 0.35s ease-in-out ;
}
.sort {
  left: -45% ;
  transition: left 0.35s ease-in-out;
}
.sort-width {
  width: 1rem ;
  transition: width 0.35s ease-in-out;
}

@keyframes rotate {
  0% {
    transform: rotate(0);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.rotate-box {
  transition: 6s;
  animation: rotate 6s linear infinite;
}
.long-width {
  width: 6.3rem !important;
  transition: width 0.35s ease-in-out;
}

.close {
  display: inline-block;
  width: 0.4rem;
  height: 0.4rem;
  position: absolute;
  top: 0rem;
  right: 0.05rem;
  font-size: 0.3rem !important;
}
.audio-box {
  position: absolute;
  // bottom: 800px;
  left: 0.8%;
  width: 6.3rem;
  display: block;
  overflow: hidden;
  height: 1rem;
  z-index: 10000;
  background-color: #ffffff;
  border-radius: 0.11rem;
  padding: 0.14rem 0.11rem;
  box-shadow:10px 0 5px -1px #ccc, //左边阴影

0 -1px 5px -1px #ccc, //顶部阴影

10px 0px 5px -1px #ccc, //底部阴影

0px 7px 5px -1px #ccc; //右边阴影
  box-sizing: border-box;
  .check-audio {
    width: 0.72rem;
    height: 0.72rem;
    border-radius: 50%;
    background-color: rgb(255, 214, 93);
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    .play-img {
      z-index: 10;
      width: 0.24rem;
      height: 0.24rem;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
    }
    .corver-img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
  .progress-list {
    width: 5rem;
    height: 0.62rem;
    // background-color: yellow;
    position: absolute;
    left: 0.73rem;
    top: 10px;
    padding-left: 0.2rem;
    box-sizing: border-box;
    .title {
      color: rgb(67, 67, 67);
      font-size: 0.14rem;
      padding-left: 0.05rem;
      .scence-name {
        font-size: 0.2rem;
        display: inline-block;
        vertical-align: top;
        max-width: 3.2rem;
      }
      .distance {
        background-color: #e6e6e6;
        font-size: 0.11rem;
        color: #4d4d4d;
        padding: 0.04rem 0.1rem;
        border-radius: 0.1rem;
        margin-left: 0.1rem;
        font-size: 0.15rem;
        display: inline-block;
        vertical-align: top;
      }
    }
    .distan {
      font-size: 0.11rem !important;
      margin-left: 0.18rem;
      background-color: rgb(237, 232, 239);
      padding: 0.02rem 0.1rem;
      border-radius: 0.1rem;
    }
    .progress {
      display: inline-block;
      width: 2.9rem;
      height: 2px;
      margin: 0 12px;
      background-color: rgb(242, 242, 242);
      position: relative;
      .progress-item {
        width: 0.085rem;
        height: 0.085rem;
        display: block;
        position: absolute;
        left: 0;
        top: -0.042rem;
        background-color: rgb(255, 214, 93);
        border-radius: 50% !important;
      }
      .progress-total {
        width: 0;
        height: 2px;
        background-color: rgb(255, 214, 93);
        position: absolute;
        left: 0;
        top: 0;
      }
    }
    .fastsecond {
      width: 0.29rem;
      height: 0.29rem;
      font-size: 0.16rem;
    }

    .content {
      line-height: 0.24rem;
      height: 0.24rem;
      display: flex;
      align-items: center;
      margin-top: 0.1rem;
      color: rgb(155, 154, 159);
      .time {
        font-size: 0.16rem;
        vertical-align: baseline;
        line-height: 0.16rem;
        display: inline-block;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/audio.vue